<template>
  <client-only>
    <Teleport to="#teleport-breadcrumb">
      <i18nLink
        :to="{ name: routeName }"
        v-if="routeName === routeName"
        :class="$style.link"
      >
        <LayoutTextWithBarComponent>{{ title }}</LayoutTextWithBarComponent>
      </i18nLink>
    </Teleport>
  </client-only>

  <client-only>
    <Teleport to="#teleport-link-to-close">
      <i18nLink
        :to="{ name: 'index' }"
        v-if="routeName === routeName"
        :class="$style.link"
      >
        <LayoutTextWithBarComponent>{{ $t('shared.close') }}</LayoutTextWithBarComponent>
      </i18nLink>
    </Teleport>
  </client-only>

  <LayoutGridComponent
    v-if="introduction"
    :class="$style.grid"
  >
    <LayoutIntroductionComponent
      :class="$style.introduction"
      :introduction="introduction"
    />

    <CoreImageComponent
      v-if="coverImage"
      :class="$style.image"
      :image="coverImage"
    />
  </LayoutGridComponent>
</template>

<script setup>
const nuxtApp = useNuxtApp()
const routeName = computed(() => {
  return props?.routeName || nuxtApp.$getRouteBaseName()
})

const props = defineProps({
  pageData: Object,
  routeName: String
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData))
})

const title = computed(() => {
  return localizedData?.value?.titles?.current_locale || localizedData?.value?.titles?.i18n_string_en
})

const introduction = computed(() => {
  return localizedData?.value?.introductions?.current_locale || localizedData?.value?.introductions?.i18n_richtext_en
})

const coverImage = computed(() => {
  return localizedData?.value?.cover_image?.data?.attributes
})
</script>

<style module>
.grid {
  padding: 0 var(--unit--horizontal--double);
}

.introduction {
  max-width: var(--container--default--without-padding);
  width: 100%;
}

.image {
  max-width: calc(var(--container--default--without-padding) / 2);
  width: 100%;
  margin: auto;
}

.link:global(.router-link-exact-active) {
  color: var(--color--accent);
}
</style>
